let state = {
  TemisCivil_Catalogos_TipoPromocionId: -1,
  TemisCivil_Catalogos_TipoMensajeriaId: -1,
  TemisCivil_Catalogos_UsuarioEquitasId: -1,
  TemisCivil_Catalogos_UsuarioDigitalizacionId: -1,
  TemisCivil_Catalogos_ZonaCivilId: -1,
  TemisCivil_Catalogos_AreaRecepcionId: -1,
  TemisCivil_Catalogos_TipoDocumentoEnvioId: -1,
  TemisCivil_Catalogos_AreaPromocionId: -1,
  TemisCivil_Catalogos_TipoInstitucionNombre: '',
  TemisCivil_Catalogos_AutoridadId: -1,
  TemisCivil_Catalogos_CargoId: -1,
  TemisCivil_Catalogos_MunicipioAbreviatura: '',
  TemisCivil_Catalogos_NombreAutoridad: '',
}

let getters = {
  Get_TemisCivil_Catalogos_TipoPromocionsId: state => {
    return state.TemisCivil_Catalogos_TipoPromocionId;
  },
  Get_TemisCivil_Catalogos_TipoMensajeriaId: state => {
    return state.TemisCivil_Catalogos_TipoMensajeriaId;
  },
  Get_TemisCivil_Catalogos_UsuarioEquitasId: state => {
    return state.TemisCivil_Catalogos_UsuarioEquitasId;
  },
  Get_TemisCivil_Catalogos_UsuarioDigitalizacionId: state => {
    return state.TemisCivil_Catalogos_UsuarioDigitalizacionId;
  },
  Get_TemisCivil_Catalogos_ZonaCivilId: state => {
    return state.TemisCivil_Catalogos_ZonaCivilId;
  },
  Get_TemisCivil_Catalogos_AreaRecepcionId: state => {
    return state.TemisCivil_Catalogos_AreaRecepcionId;
  },
  Get_TemisCivil_Catalogos_TipoDocumentoEnvioId: state => {
    return state.TemisCivil_Catalogos_TipoDocumentoEnvioId;
  },
  Get_TemisCivil_Catalogos_AreaPromocionId: state => {
    return state.TemisCivil_Catalogos_AreaPromocionId;
  },
  Get_TemisCivil_Catalogos_TipoInstitucionNombre: state => {
    return state.TemisCivil_Catalogos_TipoInstitucionNombre;
  },
  Get_TemisCivil_Catalogos_AutoridadId: state => {
    return state.TemisCivil_Catalogos_AutoridadId;
  },
  Get_TemisCivil_Catalogos_CargoId: state => {
    return state.TemisCivil_Catalogos_CargoId;
  },
  Get_TemisCivil_Catalogos_MunicipioAbreviatura: state => {
    return state.TemisCivil_Catalogos_MunicipioAbreviatura;
  },
  Get_TemisCivil_Catalogos_NombreAutoridad: state => {
    return state.TemisCivil_Catalogos_NombreAutoridad;
  },
}

let mutations = {
  M_TemisCivil_Catalogos_EstablecerTipoPromocion(state, data) {
    state.TemisCivil_Catalogos_TipoPromocionId = data;
  },
  M_TemisCivil_Catalogos_EstablecerTipoMensajeria(state, data) {
    state.TemisCivil_Catalogos_TipoMensajeriaId = data;
  },
  M_TemisCivil_Catalogos_EstablecerUsuarioEquitas(state, data) {
    state.TemisCivil_Catalogos_UsuarioEquitasId = data;
  },
  M_TemisCivil_Catalogos_EstablecerUsuarioDigitalizacion(state, data) {
    state.TemisCivil_Catalogos_UsuarioDigitalizacionId = data;
  },
  M_TemisCivil_Catalogos_EstablecerZonaCivil(state, data) {
    state.TemisCivil_Catalogos_ZonaCivilId = data;
  },
  M_TemisCivil_Catalogos_EstablecerAreaRecepcion(state, data) {
    state.TemisCivil_Catalogos_AreaRecepcionId = data;
  },
  M_TemisCivil_Catalogos_EstablecerTipoDocumentoEnvio(state, data) {
    state.TemisCivil_Catalogos_TipoDocumentoEnvioId = data;
  },
  M_TemisCivil_Catalogos_EstablecerAreaPromocion(state, data) {
    state.TemisCivil_Catalogos_AreaPromocionId = data;
  },
  M_TemisCivil_Catalogos_EstablecerTipoInstitucion(state, data) {
    state.TemisCivil_Catalogos_TipoInstitucionNombre = data;
  },
  M_TemisCivil_Catalogos_EstablecerAutoridad(state, data) {
    state.TemisCivil_Catalogos_AutoridadId = data;
  },
  M_TemisCivil_Catalogos_EstablecerCargo(state, data) {
    state.TemisCivil_Catalogos_CargoId = data;
  },
  M_TemisCivil_Catalogos_EstablecerMunicipio(state, data) {
    state.TemisCivil_Catalogos_MunicipioAbreviatura = data;
  },
  M_TemisCivil_Catalogos_EstablecerNombreAutoridad(state, data) {
    state.TemisCivil_Catalogos_NombreAutoridad = data;
  },
}

let actions = {
  A_TemisCivil_Catalogos_EstablecerTipoPromocion: ({ commit }, data) => {
    commit('M_TemisCivil_Catalogos_EstablecerTipoPromocion',data)
  },
  A_TemisCivil_Catalogos_EstablecerTipoMensajeria:({ commit }, data) => {
    commit('M_TemisCivil_Catalogos_EstablecerTipoMensajeria',data)
  },
  A_TemisCivil_Catalogos_EstablecerUsuarioEquitas:({ commit }, data) => {
    commit('M_TemisCivil_Catalogos_EstablecerUsuarioEquitas',data)
  },
  A_TemisCivil_Catalogos_EstablecerUsuarioDigitalizacion:({ commit }, data) => {
    commit('M_TemisCivil_Catalogos_EstablecerUsuarioDigitalizacion',data)
  },
  A_TemisCivil_Catalogos_EstablecerZonaCivil:({ commit }, data) => {
    commit('M_TemisCivil_Catalogos_EstablecerZonaCivil',data)
  },
  A_TemisCivil_Catalogos_EstablecerAreaRecepcion:({ commit }, data) => {
    commit('M_TemisCivil_Catalogos_EstablecerAreaRecepcion',data)
  },
  A_TemisCivil_Catalogos_EstablecerTipoDocumentoEnvio:({ commit }, data) => {
    commit('M_TemisCivil_Catalogos_EstablecerTipoDocumentoEnvio',data)
  },
  A_TemisCivil_Catalogos_EstablecerAreaPromocion:({ commit }, data) => {
    commit('M_TemisCivil_Catalogos_EstablecerAreaPromocion',data)
  },
  A_TemisCivil_Catalogos_EstablecerTipoInstitucion:({ commit }, data) => {
    commit('M_TemisCivil_Catalogos_EstablecerTipoInstitucion',data)
  },
  A_TemisCivil_Catalogos_EstablecerAutoridad:({ commit }, data) => {
    commit('M_TemisCivil_Catalogos_EstablecerAutoridad',data)
  },
  A_TemisCivil_Catalogos_EstablecerCargo:({ commit }, data) => {
    commit('M_TemisCivil_Catalogos_EstablecerCargo',data)
  },
  A_TemisCivil_Catalogos_EstablecerMunicipio:({ commit }, data) => {
    commit('M_TemisCivil_Catalogos_EstablecerMunicipio',data)
  },
  A_TemisCivil_Catalogos_EstablecerNombreAutoridad:({ commit }, data) => {
    commit('M_TemisCivil_Catalogos_EstablecerNombreAutoridad',data)
  },
}

const TemisCivil = {
  State: state,
  Getters: getters,
  Mutations: mutations,
  Actions: actions
}
export default TemisCivil;



// WEBPACK FOOTER //
// ./src/store/TemisCivil.js